module.exports = __webpack_public_path__ + "img/Number=58.310cf42e.png";